import { DigtectiveSubmitPayload } from '../types';

export function validatePayload(input: DigtectiveSubmitPayload) {
  if (!input?.adCode) return false;
  return true;
}
